import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Divider, Typography } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from 'moment';
import _ from 'lodash';

const useStyles = makeStyles((theme)=> ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
      },
    drawList: {width: 350},
}))

export default function HistoryDrawer(props) {
    const { open, toggleDrawer, historySearchSNList, handleHistorySearchSNChoose } = props;
    let list = [...historySearchSNList].reverse()
    const classes = useStyles();

    return (
        <div>
            <Drawer anchor={"right"} open={open} onClose={e=>toggleDrawer(false,e)}>
            <div className={classes.drawList}
                role="presentation"
                onClick={e=>toggleDrawer(false,e)}
                onKeyDown={e=>toggleDrawer(false,e)}
            >
                <Typography variant='h5' style={{padding: 8}}>Search History</Typography>
                <Divider />
                <List>
                    {
                        list.map((item) => (
                            <ListItem button key={item.order_id} onClick={e=>{handleHistorySearchSNChoose(item.order_id)}}>
                                <ListItemText style={{flex: 2}} primary={item.tracking_number} secondary={item.consignee} />
                                <ListItemText style={{flex: 1}} inset secondary={ moment.unix(item.search_time).format("HH:mm MMM DD")}/>
                            </ListItem>
                        ))
                    }
                </List>
            </div>
            </Drawer>         
        </div>
    )



}